import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DailyReconReportDto } from 'src/app/hist/models/daily-recon';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { HcrService } from 'src/app/services/hcr-service.service';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';

@Component({
  selector: 'app-daily-recon-report-bydate',
  templateUrl: './daily-recon-report-bydate.component.html',
  styleUrls: ['./daily-recon-report-bydate.component.css']
})

export class DailyReconReportBydateComponent implements OnInit, AfterViewInit {

  constructor(
    private localPrintService: LocalPrintService,
    private hcrService: HcrService,
    private notification: EasyNotificationService) {
  }

  @ViewChild('reportContainer', { static: false }) reportContainer: ElementRef<HTMLDivElement>;

  reportName = '日核對報表';
  sizePage = {
    width: 28.7, //cm
    height: 20 //cm
  };
  paddingPage = {
    top: -0.5, // cm
    right: 0, // cm
    bottom: 0.2, // cm
    left: 0 // cm
  };
  heightPageWithoutPadding = this.convertCmtoPx(
    this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
  ) - 30;

  forExcel = false;
  listItems: DailyReconReportDto[];  //data

  nowdateStr: string = '';  //印表日期
  nowtimeStr: string = '';  //印表時間
  totalRecord: number = 0;  //總筆數
  _sDate: string = '';   //查詢期間起
  _eDate: string = '';   //查詢期間訖

  elContainer: HTMLElement;

  upperboundIndex: number = 0;
  pageContent = [[]];     // Ex: [[0, 1, 2, 3], [4, 5]]

  ngOnInit(): void {
    this.pageContent = [[]];
  }

  ngAfterViewInit() {
    var style = document.createElement('style');
    style.textContent =
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report2 table{ border:0px solid black; border-collapse: collapse; width: 100%; }\n' +
      '.pres-report2 table td, table th { border-bottom: 1px solid black; padding-left: 5px;padding-right: 5px; }\n' +
      '.pres-report2 table tr:first-child th { border-top: 0; vertical-align: bottom; padding: 0px }\n' +
      '.pres-report2 table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report2 table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report2 table tr td:last-child, table tr th:last-child { border-right: 0; }\n' +
      '.content { overflow: visible; }\n' +
      '@page { size: A4 landscape; margin: 0.5cm 0.5cm; }\n';

    this.reportContainer.nativeElement.appendChild(style);
  }

  clearData() {
    if (this.elContainer) {
      this.elContainer.innerHTML = '';
    }
    this.listItems = [];
    this.totalRecord = 0;
  }

  convertCmtoPx(cm) {
    return Math.round((cm * 96) / 2.54);
  }

  getHtml(): string {
    // 取得整個 reportContainer 的內容，包含 CSS 樣式
    var html = this.reportContainer.nativeElement.innerHTML;

    // 移除 box-shadow 樣式（列印時不需要）
    for (var i = 0; i <= this.upperboundIndex; i++) {
      html = html.replace('box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);', '');
    }

    return html;
  }

  async exportAsExcel() {
    this.forExcel = true;

    if (this.totalRecord > 0) {
      // 找出總計行資料
      var totalRow = this.listItems.find(item => item.IsSummary === true);

      // 簡化版表頭 HTM
      const headerHtml = this.createHTMLPageHeader(0, true); // isSimpleVersion = true

      // 欄位標題 HTML
      const listHeaderHtml = this.createHTMLListHeader();

      // 資料內容 HTML
      let dataHtml = '';
      for (let i = 0; i < this.totalRecord; i++) {
        // 跳過總計行，最後再添加
        if (this.listItems[i].IsSummary === true) {
          continue;
        }
        dataHtml += this.createHTMLBlock(this.listItems[i]);
      }

      // 總計行 HTML
      const totalHtml = totalRow ? this.createHTMLTotal(totalRow) : "";

      // 組合完整的表格 HTML，不包 <table> 標籤，因為 ExportTableToExcel 會自動添加
      const completeTableHtml = `
        ${headerHtml}
        ${listHeaderHtml}
        ${dataHtml}
        ${totalHtml}
      `;

      await this.hcrService.ExportTableToExcel(this.reportName, completeTableHtml);
    } else {
      this.notification.showInfo('查無資料可供匯出!');
    }
  }

  async onPrint() {
    if (this.totalRecord > 0) {
      const printContents = this.getHtml();
      var ret = await this.localPrintService.printHtml(444, this.reportName, printContents);
      if (ret.Successed) {
        this.notification.showSuccess(this.reportName + '已送出列印!', true);
      } else {
        this.notification.showError(this.reportName + '送出列印失敗!');
      }
    } else {
      this.notification.showInfo('查無資料可供列印!');
    }
  }

  async fetchData(data: DailyReconReportDto[], forExcel = false, startDate: Date, endDate: Date) {
    this.forExcel = forExcel;
    this.elContainer = document.getElementById("container");

    //以下是報表表頭欄位
    this.nowdateStr = DateHelper.getROCDateStringWithSepetator(DateHelper.today);
    this.nowtimeStr = DateHelper.getTimeString(new Date(), ':', true);
    this._sDate = DateHelper.getROCDateStringWithSepetator(startDate);
    this._eDate = DateHelper.getROCDateStringWithSepetator(endDate);

    this.listItems = data;
    this.totalRecord = this.listItems.length;
    this.insertListData();
  }

  // #region 組報表
  // 組報表的html內容
  insertListData() {
    var html_Block = "";
    var iPage = 0;
    var iBlock = 0;
    this.elContainer.innerHTML = this.createHTMLPage(iPage);  // 整份報表的html內容
    var html_header = this.createHTMLPageHeader(iPage);       // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader();      // List欄位顯示名稱
    var html_finish = this.createHTMLFinish();                // 報表結束 -- 以下空白

    // 總計
    var totalRow = this.listItems.find(item => item.IsSummary === true);
    var html_total = totalRow ? this.createHTMLTotal(totalRow) : "";

    var html_blank = this.createHTMLBlankLine();
    var elPageContent = document.getElementById("page-" + iPage + "-content");  // 取得某頁的content，每次查詢後會取第0頁
    var prevTableContent: any;
    var afterSummary = false;

    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;

    for (let i = 0; i < this.totalRecord; i++) {
      // 跳過總計行, 最後再添加
      if (this.listItems[i].IsSummary === true) {
        continue;
      }

      // 加入 List 每一筆的內容
      prevTableContent = elTableContent.innerHTML;
      if (afterSummary) {
        elTableContent.innerHTML += html_ListerHeader;
        afterSummary = false;
      }
      html_Block = this.createHTMLBlock(this.listItems[i]);

      elTableContent.innerHTML += html_Block;

      // 判斷是否超出頁面範圍? -> 新增一頁
      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-content");
        elTableContent.innerHTML = html_ListerHeader;
        elTableContent.innerHTML += html_Block;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        this.pageContent[iPage].push(iBlock);
      }

      // 報表畫面設計因素，如果遇到合計，後面要空一行再加入清單欄位表頭
      if ((this.listItems[i].IsSummary) && !(i == this.totalRecord - 1))
      {
        afterSummary = true;
        prevTableContent = elTableContent.innerHTML;
        elTableContent.innerHTML += html_blank;
        if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          // [頁表頭][List欄位顯示名稱]
          html_header = this.createHTMLPageHeader(iPage);
          elPageContent.innerHTML += html_header;
          elTableContent = document.getElementById("table-" + iPage + "-content");
          elTableContent.innerHTML = html_ListerHeader;
          elTableContent.innerHTML += html_blank;

          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }
      }
      iBlock += 1;
    }

    // 在最後添加總計行
    if (totalRow) {
      prevTableContent = elTableContent.innerHTML;
      elTableContent.innerHTML += html_total;

      // 判斷是否超出頁面範圍? -> 新增一頁
      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-content");
        // 注意：VisitcountListComponent 這裡沒有 html_ListerHeader，只加 html_total
        elTableContent.innerHTML += html_total;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        this.pageContent[iPage].push(iBlock);
      }
    }

    elPageContent.innerHTML += html_finish;
    this.upperboundIndex = iPage;

    // 更新所有頁面的總頁數
    for (var i = 0; i <= iPage; i++) {
      var totalPage = document.getElementById("totalPage-" + i);
      if (totalPage) {
        totalPage.innerHTML = (this.upperboundIndex + 1).toString();
      }
    }
  }

  createHTMLFinish() {
    return `<div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 10px 10px 0px 10px; text-align: center; border-top: 2px double black;">
                <label style="font-weight: bold;">以下空白</label>
            </div>`;
  }

  createHTMLBlankLine() {
    return `<tr><td colspan="20" style="height: 10px; border: none;"></td></tr>`;
  }

  createHTMLPage(iPage) {
    return `
      <style>
        .excel-format {
          font-size: 14pt;
        }
        .excel-format-text {
          font-size: 14pt;
          mso-number-format: "@";
        }
      </style>
      <div class="page" id="page-` + iPage + `"
          style="
          margin: 0px auto;
          height: ` + this.sizePage.height + `cm;
          width: ` + this.sizePage.width + `cm;
          padding-top: ` + this.paddingPage.top + `cm;
          padding-right: ` + this.paddingPage.right + `cm;
          padding-bottom: ` + this.paddingPage.bottom + `cm;
          padding-left: ` + this.paddingPage.left + `cm;
          display: block;
          margin: 0px auto;
          box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);
          box-sizing: border-box;
          ">
          <div class="content" id="page-` + iPage + `-content">
          </div>
      </div>`;
  }

  createHTMLListHeader() {
    return `<tr>
        <th style="text-align: center; width: 5%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          就診日
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          時間
        </th>
        <th style="text-align: center; width: 5%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          病歷號
        </th>
        <th style="text-align: center; width: 6%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          姓名
        </th>
        <th style="text-align: center; width: 5%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          生日
        </th>
        <th style="text-align: center; width: 5%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          身分證
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          科別
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; line-height: 16px; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 4px;">
          <span style="display: block;">保險</span>
          <span style="display: block;">身分</span>
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          卡序
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          案類
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          給類
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          轉出否
        </th>
        <th style="text-align: center; width: 7%; font-size: 12pt; line-height: 16px; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 4px;">
          <span style="display: block;">主診斷</span>
          <span style="display: block;">(國際病代)</span>
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          日份
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          押金
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          自費
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; line-height: 16px; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 4px;">
          <span style="display: block;">部分</span>
          <span style="display: block;">負擔</span>
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; line-height: 16px; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 4px;">
          <span style="display: block;">藥部分</span>
          <span style="display: block;">負擔</span>
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          掛號費
        </th>
        <th style="text-align: center; width: 5%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          總額
        </th>
      </tr>`;
  }

createHTMLBlock(item: DailyReconReportDto): string {
  var commonStyle = 'border-top: none; border-bottom: none; font-size: 12pt';

  // 格式化日期
  const visitDate = item.VisitDate ? DateHelper.getROCDateStringWithSepetator(new Date(item.VisitDate)) : '';
  const visitTime = item.VisitTime ? DateHelper.getTimeString(new Date(item.VisitTime), ':', true) : '';
  const birthday = item.Birthday ? DateHelper.getROCDateStringWithSepetator(new Date(item.Birthday)) : '';

  // 數字欄位處理：空值或0都顯示為0
  const formatNumber = (value: number | null | undefined): string => {
    return (value == null || value == 0) ? "0" : value.toString();
  };

  // 定義 style
  const textStyle = this.forExcel
    ? `text-align: center; padding-top: 10px; ${commonStyle}; mso-number-format:'@';`
    : `text-align: center; padding-top: 10px; ${commonStyle}`;

  const textStyleLeft = this.forExcel
    ? `text-align: left; padding-top: 10px; ${commonStyle}; mso-number-format:'@';`
    : `text-align: left; padding-top: 10px; ${commonStyle}`;

  const numberStyle = this.forExcel
    ? `text-align: right; padding-top: 10px; ${commonStyle}; mso-number-format:'0';`
    : `text-align: right; padding-top: 10px; ${commonStyle}`;

  return `
    <tr>
      <td style="${textStyle}">${visitDate}</td>
      <td style="${textStyle}">${visitTime}</td>
      <td style="${textStyle}">${item.PatientNo || ''}</td>
      <td style="${textStyleLeft}">${item.PatientName || ''}</td>
      <td style="${textStyle}">${birthday}</td>
      <td style="${textStyle}">${item.PatientCId || ''}</td>
      <td style="${textStyle}">${item.MedDeptCode || ''}</td>
      <td style="${textStyle}">${item.InsuranceCode || ''}</td>
      <td style="${textStyle}">${item.CardNo || ''}</td>
      <td style="${textStyle}">${item.CaseType || ''}</td>
      <td style="${textStyle}">${item.PayType || ''}</td>
      <td style="${textStyle}">${item.Referral || ''}</td>
      <td style="${textStyleLeft}">${item.MainDisease || ''}</td>
      <td style="${numberStyle}">${formatNumber(item.Days)}</td>
      <td style="${numberStyle}">${formatNumber(item.FeeLAMT)}</td>
      <td style="${numberStyle}">${formatNumber(item.AOwn)}</td>
      <td style="${numberStyle}">${formatNumber(item.APartOPD)}</td>
      <td style="${numberStyle}">${formatNumber(item.APartDrug)}</td>
      <td style="${numberStyle}">${formatNumber(item.FeeReg)}</td>
      <td style="${numberStyle}">${formatNumber(item.ADcl)}</td>
    </tr>`;
}

  createHTMLPageHeader(iPage: number, isSimpleVersion: boolean = false) {
    // 共同的標題內容
    const titleContent = `
      <tr>
        <td colspan="${isSimpleVersion ? '20' : '20'}" style="height: 30px; text-align: center; font-weight: bolder; font-size: 16pt; border-right: none; border-left: none; border-bottom: none; border-top: none;">
          ${this.reportName}
        </td>
      </tr>
      <tr>
        <td ${isSimpleVersion ? 'colspan="6"' : 'colspan="7"'} style="${isSimpleVersion ? '' : 'width: 33%; '}font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: ${isSimpleVersion ? 'left' : 'left'}; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
          印表日期 ${this.nowdateStr}
        </td>
        <td colspan="${isSimpleVersion ? '7' : '6'}" style="${isSimpleVersion ? '' : 'width: 34%; '}font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: ${isSimpleVersion ? 'center' : 'center'}; border-right: none; border-left: none; border-bottom: none; border-top: none;">
          期間：${this._sDate} 至 ${this._eDate}
        </td>
        <td ${isSimpleVersion ? 'colspan="7"' : 'colspan="7"'} style="${isSimpleVersion ? '' : 'width: 33%; '}font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
          總筆數 ${this.totalRecord > 0 ? (this.listItems.some(item => item.IsSummary) ? this.totalRecord - 1 : this.totalRecord) : 0}
        </td>
      </tr>
      <tr>
        <td ${isSimpleVersion ? 'colspan="6"' : 'colspan="6"'} style="font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
          印表時間 ${this.nowtimeStr}
        </td>
        <td colspan="${isSimpleVersion ? '8' : '6'}" style="font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
        </td>
        ${!isSimpleVersion ? `
        <td colspan="8" style="font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
          頁 ${(iPage + 1)}/<span id="totalPage-${iPage}"></span>
        </td>` : `
        <td colspan="6" style="font-size: ${isSimpleVersion ? '14px' : '12px'}; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
        </td>`}
      </tr>
      ${isSimpleVersion ? '<tr><td colspan="20" style="height: 10px; border: none;"></td></tr>' : '<tr><td colspan="20" style="height: 10px; border: none;"></td></tr>'}
    `;

    // Excel 匯出：只回傳表格內容，不包含外層 div 結構
    if (isSimpleVersion) {
      return titleContent;
    }

    // 列印 (PDF)：包含完整的 div 結構和分頁相關元素
    return `<div id="header" style="margin: 0px 20px;">
              <div style="display: flex;column-gap: 5px;">
                <table style="width: 100%; text-align: center; border: none;">
                  ${titleContent}
                </table>
              </div>
            </div>
            <div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 0px 10px; text-align: center;">
                <label style="font-weight: bold; height: 23px;">　</label>
            </div>
            <div style="-webkit-text-size-adjust: none; font-size: 12px;zoom: 0.8;margin: 0px 10px;">
                <div style="display: flex;column-gap: 5px;">
                    <table id="table-${iPage}-content" style="width: 100%; font-size: 12pt; text-align: center; border: none; line-height: 0.5; border-collapse: collapse;">
                    </table>
                </div>
            </div>`;
  }

  createHTMLTotal(data: DailyReconReportDto) {
    // 預覽和列印時要有空白行，匯出EXCEL時不要
    const blankRow = this.forExcel ? '' : `
      <tr>
        <td colspan="20" style="height: 10px; border: none;"></td>
      </tr>`;

    // 數字欄位處理：確保空值或0顯示為數字格式
    const formatNumber = (value: number | null | undefined): string => {
      return (value == null || value == 0) ? "0" : value.toString();
    };

    const commonClassNumber = this.forExcel ? 'class="excel-format"' : '';

    return `${blankRow}
      <tr>
        <td colspan="14" style="font-size: 12pt; font-weight: bold; text-align: left; padding-top: 10px; border-top: 1px solid black;">總計：</td>
        <td style="text-align: right; padding-top: 10px; border-top: 1px solid black; font-size: 12pt" ${commonClassNumber}>${formatNumber(data.FeeLAMT)}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 1px solid black; font-size: 12pt" ${commonClassNumber}>${formatNumber(data.AOwn)}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 1px solid black; font-size: 12pt" ${commonClassNumber}>${formatNumber(data.APartOPD)}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 1px solid black; font-size: 12pt" ${commonClassNumber}>${formatNumber(data.APartDrug)}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 1px solid black; font-size: 12pt" ${commonClassNumber}>${formatNumber(data.FeeReg)}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 1px solid black; font-size: 12pt" ${commonClassNumber}>${formatNumber(data.ADcl)}</td>
      </tr>`;
  }
}
